/* eslint-disable no-undef */
import axios from "axios";
import DataHandlerService from "./data";
import config from '../config'

const data = new DataHandlerService();

// create a new axios instance
const instance = axios.create({
  baseURL: config.API_ROOT
});

// check if global handling is enabled for request
const isHandlerEnabled = (config={}) => {
  return config.hasOwnProperty('handlerEnabled') && !config.handlerEnabled ? 
    false : true
}

// response handlers
const errorHandler = () => {
  NProgress.done();
  return Promise.reject({ message: "A network error occured. Please check your internet connection and try again." });
}

const successHandler = (response) => {
  NProgress.done();
  return response;
}

// before a request is made start the nprogress
instance.interceptors.request.use(config => {
  if (data.getUserSession() !== null) {
    config.headers = data.setHeader();
  }
  NProgress.start();
  return config;
});

// before a response is returned stop nprogress
instance.interceptors.response.use(response => successHandler(response), error => errorHandler());

export default instance;
